module.exports = __webpack_public_path__ + "img/item-2.ae005d53.png";